<template>
	<div>
		<div :class="{'d-sm-block':!specail&&(viewToggle||!clickToggle),'d-none':!specail&&(viewToggle||!clickToggle)}" class="col-md-4 pt-3 centre_sm_none">
			<div class="right_list_content">
				<div style="line-height: 65px;">
					<p id="right_content_title_information" class="pl-3 pr-3">
						<i class="fa fa-file-text fa-lg mr-2"></i>
							{{zineName}}
						<button class="btn genceback float-right mt-3" @click="genceback">Back</button>
					</p>
					<div class="row nano p-0 m-0 one_title_nano">
						<div class="nano-content" id="home_right_list">
							<ul class="list-unstyled">
								<li v-for="(getissue,index) in getissues"  @click.stop.prevent="getIssueDetail(getissue.eid)" class="media pb-3 pt-3 pl-3 pr-3 border-bottom mb-3" style="position: relative;">
									<img v-if="getissue.image != ''" class="mr-3 col-md-2 col-5 img-thumbnail" :src="getissue.image" style="padding: 4px;" />
									<div class="media-body">
										<h5 class="font-weight-bold"><a href="javascript:" :class="(eid==getissue.eid)?'blues':''">{{getissue.title}}</a></h5>
										<div class="media-foot mt-1 font-weight-light">
											<p class="f13 inteList mb-0">
												{{getissue.description}}
											</p>
										</div>
									</div>
								</li>
                            <p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
							</ul>
						</div>
					</div>
				</div>
			</div>
        </div>
		<div class="col-md-8 pl-0 mt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||clickToggle),'d-none':!specail&&(viewToggle||clickToggle)}">
            <div id="consult_left_content" class="pl-3" v-if="!viewToggle">
                <!--<i class="fa fa-mortar-board fa-lg mr-2"></i>咨询-->
                <span class="myBtn" @click='goback()'>Back</span>
            </div>
            <div class="h-100" v-if="!this.detailes.is_pay">

                <div class="centre_content embed-responsive">
                    <!--<div class="shares">abc</div>-->
                    <p class="text-center" v-if="this.detailes.pdf == ''"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
                    <iframe class="embed-responsive-item" name="" :src="'https://img.imsilkroad.com/pdf/web/viewer.html?file='+encodeURIComponent(this.detailes.pdf)"></iframe>
                </div>
            </div>
            <div class="h-100" v-if="this.detailes.is_pay">
                <div class="charge_hint nano">

                    <div class="centre_content nano-content">
                        <div class="card text-center" style="padding-left:1rem!important;padding-right:1rem!important;">
                            <div class="card-body p-0 mycard">
                                <NoPay :obj="detailes"></NoPay>
                                <h5 class="mb-3" style="margin-top: 10px">
                                    <img src="../../../assets/images/silkRoadBase/member.png" class="mr-2" />
                                    VIP exclusive
                                </h5>
                                <h4 class="f20 fn600">Paid subscription</h4>
                                <p class="card-text f15 text-secondary mt-3 mb-3">Buy a VIP membership to enjoy exclusive service of Xinhua Silk Road</p>
                                <a href="/db#/accountSettings/menberCenter" class="btn btn-warning mt-3 text-white">Buy now</a>
                                <p class="mt-5 mb-5">More VIP privileges</p>
                                <div class="d-flex row justify-content-around m-0 pb" :class="{'pb100':(!viewToggle)}">
                                    <div class="card col-md-4 col-12 p-0">
                                        <div class="card-body">
                                            <img src="../../../assets/images/silkRoadBase/56878730129766812.png" />
                                            <h5 class="card-title mt-3 mb-3">Analyst service</h5>
                                            <h6 class="card-subtitle mb-2 text-muted">180 overseas branches of Xinhua News Agency, and chief reporters' observations and interaction with them</h6>
                                        </div>
                                    </div>
                                    <div class="card col-md-4 col-12 p-0">
                                        <div class="card-body">
                                            <img src="../../../assets/images/silkRoadBase/41408370476170076.png" />
                                            <h5 class="card-title mt-3 mb-3">Consulting service</h5>
                                            <h6 class="card-subtitle mb-2 text-muted">Research trends and achievements of more than 100 top think tanks and consulting institutions in the world</h6>
                                        </div>
                                    </div>
                                    <div class="card col-md-4 col-12 p-0">
                                        <div class="card-body">
                                            <img src="../../../assets/images/silkRoadBase/507574572099684577.png"/>
                                            <h5 class="card-title mt-3 mb-3">Overseas activities service</h5>
                                            <h6 class="card-subtitle mb-2 text-muted">Latest information inquiry and release of investment projects home and abroad</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="modal fade" id="buyModal">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h4 class="modal-title">Payment</h4>
                                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    </div>

                                    <!-- 模态框主体 -->
                                    <div class="modal-body">
                                        <div class="card border-bottom">
                                            <div class="card-body">
                                                <div class="d-flex w-100 abc" style="">
                                                    <div class="">
                                                        <img :src="this.detailes.image"  v-if="this.detailes.image" class="img-fluid" style="width: 76px; height: 100px;" />
                                                    </div>
                                                    <div class="flex-grow-1 ml-3">
                                                        <p class="f15 pb-2 myfont">{{this.detailes.title}}</p>
                                                        <p class="desp">{{this.detailes.description}}</p>
                                                        <div class="">
                                                            <p class="f14 float-left mb-0 text-black-50">Purchase a single article</p>
                                                            <p class="f22 float-right mb-0 text-secondary mcur">Amount：{{this.detailes.price}} USD</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="w-100">
                                                    <div class="text-center mb-2">

                                                        <button @click="checkpays('wechat')" :class="{checkpay:checkpay=='wechat'}" type="button" class="btn f16 mr-5 mybtn">
                                                        <img src="../../../assets/images/silkRoadBase/weixinPay.png" class="img-fluid mr-2" style="width: 20px; height: 20px;" />WeChat Pay
                                                    </button>
                                                    <button @click="checkpays('alipay')" :class="{checkpay:checkpay=='alipay'}" type="button" class="btn f16 mybtn mr-5">
                                                    <img src="../../../assets/images/silkRoadBase/zhifubaoPay.png" class="img-fluid mr-2" style="width: 20px; height: 20px;" />Alipay
                                                </button>
                                                        <button @click="checkpays('paypal')" :class="{checkpay:checkpay=='paypal'}" type="button" class="btn f16 mybtn cur">
                                                            <img src="../../../assets/images/silkRoadBase/paypal.png" class="img-fluid mr-2" style="width: 83px; height: 20px;" />PayPal
                                                        </button>
                                            </div>
                                            <div class="text-center" v-show="checkpay==='wechat'">
                                                <div id="payQrcode" style="width:150px;height: 150px;margin: 5px auto;"></div>
                                                <p class="f16">
                                                    <img src="../../../assets/images/silkRoadBase/weixinPay.png" class="img-fluid mr-2" style="width: 20px; height: 20px;" /> WeChat Pay, {{this.detailes.price}} USD

                                                </p>
                                            </div>
                                            <div class="text-center" v-show="checkpay==='alipay'">
                                                <p>
                                                    <!--<img src="../../../assets/images/silkRoadBase/二维码.gif" class="img-fluid" />-->
                                                </p>
                                                <p class="f16">

                                                    <img src="../../../assets/images/silkRoadBase/zhifubaoPay.png" class="img-fluid mr-2" style="width: 20px; height: 20px;" /> Alipay, {{this.detailes.price}} USD
                                                </p>
                                            </div>
                                                    <div class="text-center" v-show="checkpay==='paypal'">
                                                        <p>
                                                            <!--<img src="../../../assets/images/silkRoadBase/二维码.gif" class="img-fluid" />-->
                                                        </p>
                                                        <p class="f16">

                                                            <img src="../../../assets/images/silkRoadBase/paypal.png" class="img-fluid mr-2" style="width: 83px; height: 20px;" /> PayPal, {{this.detailes.price}} USD
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-inline-block w-100 pl-3 pr-3 mt-2 myfix" style="line-height: 70px;box-shadow:0px 0px 5px 0px rgba(0,0,0,0.05);">
                        <span class="" style="display:block;height:40px;font-size:14px;font-family:PingFangSC-Regular;font-weight:600;color:rgba(0,0,0,1);line-height:40px;border-bottom:1px solid #F5F6F7">Or you can purchase a single article</span>
                        <div class="float-left">
                            <img :src="this.detailes.image" v-if="this.detailes.image" class="img-fluid" style="width: 34px; height: 45px;"/>
                        </div>
                        <div class="float-left ml-3">
                            <p class="f14 mb-0 titleBreviary pb-2 w-99" style="line-height: 40px;">{{this.detailes.title}}</p>
                            <p class="f12 mb-0 text-black-50" style="line-height: 13px;">Purchase a single article</p>
                        </div>
                        <div class="float-right ml-3">
                            <div>
                                <button class="btn btn-primary f15" data-toggle="modal" data-target="#buyModal" @click="checkpays('wechat')">Purchase a single article</button>
                            </div>
                        </div>
                        <div class="float-right">
                            <p class="f15">Amount：{{this.detailes.price}} USD</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import QRCode from 'qrcodejs2'
    import NoPay from './noPay'
    export default({
		name: 'custom_reports',
        components: {
            NoPay
        },
        data: function() {
            return {
                checkpay: '',
                getissues:[],
                getzines:[],
                id: this.$route.params.id,
                eid: this.$route.params.issueid,
                reid:'',
                page: 1,
                detailes:'',		//pdf详情链接
                page_size: 10,
                total_page: 1,
                zineName:'',		//报告
                viewToggle:true,
                clickToggle:true,
                out_trade_no: '',
                specail:false, //特殊处理 小于544px
                timer: null,
                loadShow : false // 请求响应等待， 如果不等待，可能会造成数据错乱
            }
        },
        created: function() {
            var self = this;
            if(this.IsPC()&&(document.body.clientWidth<=700)){
                this.specail=true
            }else{
                this.specail=false
            }
            this.viewToggle=this.IsPC();
            this.$axios.post('/api/pc/getissue', {
				id: self.id,
				current_page: self.page,
				page_size: self.page_size
			}).then(data => {
				var getissues = data.data.data.data;
				self.total_page = Math.ceil(data.data.data.total / self.page_size);
				self.getissues = getissues;
			})
            this.getZineName(this.id);
            this.getIssueDetail(this.eid);
        },
        mounted() {
			document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
            this.load();
        },
        computed: {
            isFollow () {
                return this.$store.state.screenWidth;
            }
        },
        methods : {
            goback(){
                if(this.viewToggle){
                    // this.$router.push({name:'consult_particulars_organization',params :{id:"10",type:1}})
                }else{
                    this.clickToggle=true;
                }

            },
        	handleScroll() {
				var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
				var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
				var all = document.getElementById('home_right_list').scrollHeight; // 总高度
				if((all - 20) < (top + client) && !this.loadShow) {
					this.page++;
					if(this.page > this.total_page) {
						return;
					}
					let that = this;
					that.loadShow = true;
					this.$axios.post('/api/pc/getissue', {
						id: that.id,
						current_page: that.page,
						page_size: that.page_size
					}).then(data => {
						var getissues = data.data.data.data;
						that.getissues = that.getissues.concat(getissues);
						that.loadShow = false;
					})
				}
			},
			getIssueDetail : function(eid) {
                this.eid = eid;

				let that = this;
				that.pdfdetail ='';
                this.clickToggle=false;
                this.$axios.post('/api/pc/getissuedetail',{id:eid}).then(data => {
                    that.detailes = data.data.data;
                    this.statistics();
                })
            },
            genceback:function(){
            	let that = this;
            	that.$router.push({name: 'report', params: { id: this.$route.params.id}});
            },
            getZineName:function(id) {
                this.$axios.post('/api/pc/getzine',{id:id}).then(data => {
                    this.zineName=data.data.data.name;
                })
            },
            checkpays:function(index){
                if (this.checkpay != index) {
                    this.checkpay=index;
                    this.pay();
                }
            },
            pay:function() {
                var self = this;
                this.$axios.post('/api/pc/pay', {
                    order_type : 'issue_page',
                    pay_type : this.checkpay,
                    product_id : this.eid,
                    origin_url : window.location.href
                }).then(response => {
                    if (this.checkpay == 'alipay') {
                        if (response.data.state) {
                            $('#buyModal').append(response.data.data.content);
                        }
                    }
                    if (this.checkpay == 'wechat' ) {
                        if (response.data.state) {
                            self.out_trade_no = response.data.data.out_trade_no;
                            document.getElementById("payQrcode").innerHTML = "";
                            new QRCode('payQrcode', {
                                width: 150,
                                height: 150, // 高度  [图片上传失败...
                                text:  response.data.data.content// 二维码内容
                                // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                                // background: '#f0f'
                                // foreground: '#ff0'
                            })
                            // 两秒之后执行轮训
                            setTimeout(this.checkPayResult, 2000);
                        }
                    }
                    if (this.checkpay == 'paypal' ) {
                        if (response.data.state) {
                            //window.open(response.data.data.url);
                            window.location.href=response.data.data.url
                        }
                    }

                })
            },
            // 检查订单状态
            checkPayResult:function() {
                clearInterval(this.timer);
                if(this.checkpay == 'wechat') {
                    this.timer = setInterval(() => {
                            this.$axios.post('/api/pc/payresult', {
                            out_trade_no : this.out_trade_no
                        }).then(response => {
                            if (response.data.data.state == 6) {
                                $(".wrap").text('Successful payment！');
                                $(".wrap").show().delay(1500).hide(100);
                                clearInterval(this.timer);

                                // 关闭弹框
                                $('#buyModal').modal('hide')

                                // 重新获取右侧文章
                                this.getIssueDetail(this.eid);
                            }
                        })

                },1000);
                }
            },
            // 统计
            statistics:function(){
                document.getElementById('staticData').remove();
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.id = 'staticData';
                s.innerHTML = "_paq.push(['eventBrowse', '10001qk_"+this.eid+"', {'title': '"+this.detailes.title+"','catName': '"+this.zineName+"'}, 1]);_paq.push(['eventCustom', 'CAT', {'catName': '"+this.zineName+"'}, 1]);_paq.push(['trackPageView']);";
                document.getElementsByTagName("head")[0].appendChild(s);
            }

        },
        watch: {
            $route(){
            	let that = this;

                that.id = this.$route.params.id;

                that.reid = JSON.parse(this.$route.params.id);

                that.eid = this.$route.params.issueid
            },
            eid() {
//                this.getIssueDetail(this.eid,this.currentIndex)
            },
            isFollow (val) {
                if (!this.timer) {
                    //this.screenWidths = val;
                    this.timer = true;
                    let that = this;
                    setTimeout(function () {
                        if(that.IsPC()&&(val<=700)){
                            that.specail=true
                        }else{
                            that.specail=false
                        }
                        that.timer = false
                    }, 300)
                }

            },
            id() {
                if ($.inArray(this.id, ['22', '23', '24']) >= 0) {
                    this.$router.push({path:'/countryreport/'+this.id+'/2018/'+this.eid})
                }
            }
        }
	})
</script>
<style scoped>
    .myBtn{
        width:60px;
        height:30px;
        display:block;
        position:absolute;
        top:8px;
        right:35px;
        /*z-index: 10;*/
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:30px;
        text-align:center;
        background:rgba(242,243,244,1);
        border-radius:20px;
    }
    .myBtn:hover{
        cursor:pointer;
    }
    #consult_left_content{
        height:65px;
        background:white;
    }
    .mycard{
        padding-bottom:110px!important;
    }
    .blues{
        color:#208EFF
    }
.card-subtitle{
    font-size:12px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(133,144,166,1);
    line-height:20px;
}
    .myfix{
        position: absolute;
        bottom: 0;
        left: 0;
        /*padding-top:10px;*/
        background:rgba(255,255,255,1);
        box-shadow:0px -2px 5px 0px rgba(0,0,0,0.05);
    }
    .modal-dialog{
        max-width: 600px;
    }
    .desp{
        overflow:hidden;
        text-overflow:ellipsis;
        margin-bottom: 22px;
        white-space:nowrap;
        font-size:13px;
        height:30px;
        max-width: 400px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:30px;
    }
    .myfont{
        margin-bottom: 0;
    }
    .mcur{
        line-height: 18px;
    }
    .abc{
        display: flex;
        justify-content: space-between;
    }
    .shares{
        position: fixed;
        right: 30px;
        top: 200px;
    }
    @media screen and (max-width: 600px){
        #consult_left_content{
            height:50px;
        }
        .myfix{
            position: fixed;
        }
        .abc{
            display: block!important;
            text-align: center;
        }
        .abc>div{
            width:auto;
            margin-top: 15px;
        }
        .mybtn:nth-child(1){
            margin-right:0!important;
        }
        .mycard>h5{
            margin-top:10px!important;
        }
        .card-body{
            padding:.5rem 0;
        }
        .desp{
            margin-bottom: 10px;
        }
        .mt-40{
            margin-top: 30px;
        }
        .aaas{
            display: block;
        }
        .myfont{
            height: auto;
        }

    }
</style>
